import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { format as formatDate, parseISO } from 'date-fns';

export default class SensorEquipmentService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Sensor Equipment';
    const entityPluralName = 'Sensor Equipment';

    super({ entityName, entityPluralName, mode });
  }

  public getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  public getColumns(props: any): any {
    /* Do Nothing */
  }

  public getFields(props: any): React.ReactElement {
    return <></>;
  }

  public getValidations(props?: any): any {
    /* Do Nothing */
  }

  public mapFormToDTO(props: any): any {
    const { entity, sensorData, ...rest } = props;

    return {
      ...sensorData,
      SerialNumber: entity.serialnumber,
      FirmwareVersion: entity.firmwareversion,
      ModelId: entity.modelid ? entity.modelid.value.toString() : '0',
      SensorStatusId: entity.sensorstatusid ? entity.sensorstatusid.value : 0,
      InstallationDate: isValueEmpty(entity.installationdate) ? '' : formatDate(entity.installationdate, 'yyyy-MM-dd'),
      DecommissionDate: isValueEmpty(entity.decommissiondate) ? '' : formatDate(entity.decommissiondate, 'yyyy-MM-dd'),
      StructuredAttributes: entity.sensorMetadata,
    };
  }

  public mapInitialValues(props: any): any {
    const { entity, getDefaultSensorStatus, ...rest } = props;
    return {
      id: entity.Id ?? '',
      serialnumber: entity.SerialNumber ?? '',
      firmwareversion: entity.FirmwareVersion ?? '',
      modelid: entity.ModelId
        ? { value: parseInt(entity.ModelId), label: entity.ModelNumber }
        : { value: 0, label: 'Select...' },
      sensorstatusid: entity.SensorStatusId
        ? { value: entity.SensorStatusId, label: entity.SensorStatusName }
        : getDefaultSensorStatus(),
      installationdate: isValueEmpty(entity.InstallationDate) ? '' : parseISO(entity.InstallationDate),
      decommissiondate: isValueEmpty(entity.DecommissionDate) ? '' : parseISO(entity.DecommissionDate),
      metaConditions: entity.metaConditions === '{}' ? '' : entity.metaConditions ?? '',
      sensorMetadata: entity.StructuredAttributes ?? '',
    };
  }

  cleanFormValues(props: EntityProps): any {
    const { entity, ...rest } = props;

    return {
      ...entity,
      metaConditions: entity.metaConditions === '{}' ? '' : entity.metaConditions,
      decommissiondate: isValueEmpty(entity.decommissiondate) ? '' : entity.decommissiondate,
      installationdate: isValueEmpty(entity.installationdate) ? '' : entity.installationdate,
    };
  }
}
